import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import AddAreaForm from "./views/admin/AddAreaForm.vue";
import AddDeviceForm from "./views/admin/AddDeviceForm.vue";
import AddOnlineOrderForm from "./views/admin/AddOnlineOrderForm.vue";
import AddPurchaseOrderForm from "./views/admin/AddPurchaseOrderForm.vue";
import AddMovementOrderForm from "./views/admin/AddMovementOrderForm.vue";
import AddLocationForm from "./views/admin/AddLocationForm.vue";
import AddPrinterForm from "./views/admin/AddPrinterForm.vue";
import AddVisualizerForm from "./views/admin/AddVisualizerForm.vue";
import DevicesList from "./views/admin/DevicesList.vue";
import EditAreaForm from "./views/admin/EditAreaForm.vue";
import EditDeviceForm from "./views/admin/EditDeviceForm.vue";
import EditLocationForm from "./views/admin/EditLocationForm.vue";
import EditPrinterForm from "./views/admin/EditPrinterForm.vue";
import EditVisualizerForm from "./views/admin/EditVisualizerForm.vue";
import LocationsList from "./views/admin/LocationsList.vue";
import PrintersList from "./views/admin/PrintersList.vue";
import PrintDetails from "./views/admin/PrintDetails.vue";
import PrintOrderDetails from "./views/admin/PrintOrderDetails.vue";
import PrintOrderList from "./views/admin/PrintOrderList.vue";
import GeneratePrinterOrder from "./views//printer/GeneratePrinterOrder.vue";
import GeneratePrinterOrderManual from "./views//printer/GeneratePrinterOrderManual.vue";

import UploadPrinterFile from "./views/admin/UploadPrinterFile.vue";
// ADMIN VIEWS
import UserLocationsList from "./views/admin/UserLocationsList.vue";
import Alarm from "./views/Alarm.vue";
import BoxVerificationList from "./views/PURCHASES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationList.vue";
import BoxVerificationView from "./views/PURCHASES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationView.vue";
import BoxVerificationViewItems from "./views/PURCHASES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationViewItems.vue";

// CHART
import Chart from "./views/Chart.vue";
import Dashboard from "./views/Dashboard.vue";
import EditMinstock from "./views/EditMinstock.vue";
import InboundBoxDetail from "./views/PURCHASES/DETALLE_CAJA/BoxDetail.vue";
import InboundContainerDetail from "./views/containers/InboundContainerDetail.vue";
import InboundContainers from "./views/containers/InboundContainers.vue";
import InboundDashboard from "./views/PURCHASES/PordersDashboard.vue";
import InboundOrderBoxesDetail from "./views/PURCHASES/DETALLE_CAJA/PordersBoxes.vue";
import InboundOrderDetail from "./views/PURCHASES/DETALLE_ORDEN/InboundOrderDetail.vue";
import InboundOrderGTINDetail from "./views/GTINDetail.vue";
import InboundProviderDetail from "./views/InboundProviderDetail.vue";
import InventoryBoxStocks from "./views/Inventory/InventoryBoxStocks.vue";
import InventoryDashboard from "./views/Inventory/InventoryDashboard.vue";
import InventoryDetail from "./views/Inventory/InventoryDetail.vue";
import InventoryDetailItems from "./views/Inventory/InventoryDetailItems.vue";

import InventoryGTINDetail from "./views/Inventory/InventoryGTINDetail.vue";
import InventoryStocks from "./views/Inventory/InventoryStocks.vue";
import InventoryGlobalStock from "./views/Inventory/InventoryGlobalStock.vue";
import InventoryGlobalStockItems from "./views/Inventory/InventoryGlobalStockItems.vue";
import Login from "./views/Login";
import MovementEntryBoxVerificationList from "./views/ENTRY_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationList.vue";
import MovementEntryBoxVerificationView from "./views/ENTRY_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationView.vue";
import MovementEntryBoxVerificationViewItems from "./views/ENTRY_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationViewItems.vue";
import MovementsEntryDashboard from "./views/ENTRY_MOVEMENTS/EntryDashboard.vue";
import MovementEntryBoxDetail from "./views/ENTRY_MOVEMENTS/DETALLE_CAJA/EntryBoxDetail.vue";
import MovementEntryOrderBoxesDetail from "./views/ENTRY_MOVEMENTS/DETALLE_CAJA/EntryListBoxes.vue";
import MovementEntryOrderDetail from "./views/ENTRY_MOVEMENTS/DETALLE_ORDEN/EntryOrderDetail.vue";
import MovementEntryOrderGTINDetail from "./views/Movement_Entry_OrderGTINDetail.vue";
import MovementExitBoxVerificationList from "./views/EXIT_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationList.vue";
import MovementExitBoxVerificationView from "./views/EXIT_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationView.vue";
import MovementExitBoxVerificationViewItems from "./views/EXIT_MOVEMENTS/DETALLE_CAJA/VERIFICACIONES/BoxVerificationViewItems.vue";
import SaleBoxVerificationList from "./views/SALES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationList.vue";
import OrderBoxVerificationView from "./views/SALES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationView.vue";
import OrderBoxVerificationViewItems from "./views/SALES/DETALLE_CAJA/VERIFICACIONES/BoxVerificationViewItems.vue";

import MovementsExitDashboard from "./views/EXIT_MOVEMENTS/Movements_Exit_Dashboard.vue";
import MovementExitBoxDetail from "./views/EXIT_MOVEMENTS/DETALLE_CAJA/Movement_Exit_BoxDetail.vue";
import MovementExitOrderBoxesDetail from "./views/EXIT_MOVEMENTS/DETALLE_CAJA/Movement_Exit_OrderBoxesDetail.vue";
import MovementExitOrderDetail from "./views/EXIT_MOVEMENTS/DETALLE_ORDEN/Movement_Exit_OrderDetail.vue";
import MovementExitOrderGTINDetail from "./views/Movement_Exit_OrderGTINDetail.vue";
import OnlineBoxDetail from "./views/SALES/DETALLE_CAJA/OnlineBoxDetail.vue";
import OnlineDashboard from "./views/SALES/OnlineDashboard.vue";
import OnlineOrderBoxesDetail from "./views/SALES/DETALLE_CAJA/OnlineOrderBoxesDetail.vue";
import OnlineOrderDetail from "./views/SALES/DETALLE_ORDEN/OnlineOrderDetail.vue";
import OnlineOrderGTINDetail from "./views/OnlineOrderGTINDetail.vue";
import PosEntryDashboard from "./views/Pos/Entry/Pos_Entry_Dashboard.vue";
import PosEntryDetail from "./views/Pos/Entry/Pos_Entry_Detail.vue";
import PosExitDashboard from "./views/Pos/Exit/Pos_Exit_Dashboard.vue";
import PosExitDetail from "./views/Pos/Exit/Pos_Exit_Detail.vue";
import EPCDashboard from "./views/EPC/EPCDashboard.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard, // () => import(/* webpackChunkName: "elements-demo" */ './views/Dashboard.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: "/chart",
      name: "chart",
      component: Chart,
      meta: {
        auth: false
      }
    },
    {
      path: "/alarm",
      name: "alarm",
      component: Alarm,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/minstock/:gtin/edit",
      name: "editMinstock",
      component: EditMinstock,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/admin/locations/add",
      name: "AddLocationForm",
      component: AddLocationForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/locations/:id/edit",
      name: "EditLocationForm",
      props: true,
      component: EditLocationForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/locations/",
      name: "LocationsList",
      component: LocationsList,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/order/add",
      name: "AddPurchaseOrder",
      component: AddPurchaseOrderForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/order/add",
      name: "AddMovementOrder",
      component: AddMovementOrderForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/track-epc",
      name: "EPCDashboard",
      component: EPCDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/add",
      name: "AddOnlineOrder",
      component: AddOnlineOrderForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/devices/add",
      name: "AddDeviceForm",
      component: AddDeviceForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/printer/add",
      name: "AddPrinterForm",
      component: AddPrinterForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/cixxonia-printer/orders/add",
      name: "GeneratePrinterOrder",
      component: GeneratePrinterOrder,
      meta: {
        auth: true
      }
    },
    {
      path: "/cixxonia-printer/orders/add-manual",
      name: "GeneratePrinterOrderManual",
      component: GeneratePrinterOrderManual,
      meta: {
        auth: true
      }
    },
    {
      path: "/printer/:id/upload",
      name: "UploadPrinterFile",
      props: true,
      component: UploadPrinterFile,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/visualizers/add",
      name: "AddVisualizerForm",
      component: AddVisualizerForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/visualizers/:id/edit",
      name: "EditVisualizerForm",
      props: true,
      component: EditVisualizerForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/visualizers/locations",
      name: "UserLocationList",
      component: UserLocationsList,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/devices",
      name: "DevicesList",
      component: DevicesList,
      meta: {
        auth: true
      }
    },
    {
      path: "/printer/all",
      name: "PrintersList",
      component: PrintersList,
      meta: {
        auth: true
      }
    },
    {
      path: "/cixxonia-printer/orders",
      name: "PrintOrderList",
      component: PrintOrderList,
      meta: {
        auth: true,
        title: "Printing order"
      }
    },
    {
      path: "/printer/print/:id/detail",
      name: "PrintDetails",
      component: PrintDetails,
      meta: {
        auth: true,
        title: "Print Details"
      }
    },
    {
      path: "/ptinter/print/:id/detail",
      name: "PrintOrderDetails",
      component: PrintOrderDetails,
      meta: {
        auth: true,
        title: "Print Details"
      }
    },
    {
      path: "/admin/areas/add",
      name: "AddAreaForm",
      component: AddAreaForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/areas/:id/edit",
      name: "EditAreaForm",
      props: true,
      component: EditAreaForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/admin/devices/:id/edit",
      name: "EditDeviceForm",
      props: true,
      component: EditDeviceForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/printer/:id/edit",
      name: "EditPrinterForm",
      props: true,
      component: EditPrinterForm,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/",
      name: "inbound-dashboard",
      component: InboundDashboard, 
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/containers",
      name: "inbound-containers",
      component: InboundContainers, 
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/container/:id/detail",
      name: "inbound-container-detail",
      props: true,
      component: InboundContainerDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/order/:id/detail",
      name: "inbound-order-detail",
      props: true,
      component: InboundOrderDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/order/:id/boxes",
      name: "inbound-order-boxes-detail",
      props: true,
      component: InboundOrderBoxesDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/order/:orderId/box/:id/verifications",
      name: "BoxVerificationList",
      props: true,
      component: BoxVerificationList,
      meta: {
        auth: true
      }
    },
    {
      path: "/order/:orderId/box/:boxId/verifications/:id",
      name: "BoxVerificationView",
      props: true,
      component: BoxVerificationView,
      meta: {
        auth: true
      }
    },
    {
      path: "/order/:orderId/box/:boxId/verifications/:id/items",
      name: "BoxVerificationViewItems",
      props: true,
      component: BoxVerificationViewItems,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/order/:orderId/box/:id/detail",
      name: "inbound-box-detail",
      props: true,
      component: InboundBoxDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/order/:order_id/gtin/:gtin/detail",
      name: "inbound-order-gtin-detail",
      props: true,
      component: InboundOrderGTINDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/inbound/provider/:id/detail",
      name: "inbound-provider-detail",
      props: true,
      component: InboundProviderDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/",
      name: "online-dashboard",
      component: OnlineDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:id/detail",
      name: "online-order-detail",
      props: true,
      component: OnlineOrderDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:order_id/gtin/:gtin/detail",
      name: "online-order-gtin-detail",
      props: true,
      component: OnlineOrderGTINDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:id/boxes/",
      name: "online-order-boxes-detail",
      props: true,
      component: OnlineOrderBoxesDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:orderId/box/:id/detail",
      name: "online-box-detail",
      props: true,
      component: OnlineBoxDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:orderId/box/:id/detail",
      name: "movements-entry-box-detail",
      props: true,
      component: MovementEntryBoxDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:orderId/box/:id/detail",
      name: "movements-exit-box-detail",
      props: true,
      component: MovementExitBoxDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/",
      name: "movements-exit",
      component: MovementsExitDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/",
      name: "movements-exit-dashboard",
      component: MovementsExitDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/",
      name: "movements-entry-dashboard",
      component: MovementsEntryDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:id/detail",
      name: "movements-exit-order-detail",
      props: true,
      component: MovementExitOrderDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:id/detail",
      name: "movements-entry-order-detail",
      props: true,
      component: MovementEntryOrderDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:order_id/gtin/:gtin/detail",
      name: "movementS-exit-order-gtin-detail",
      props: true,
      component: MovementExitOrderGTINDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:order_id/gtin/:gtin/detail",
      name: "movementS-entry-order-gtin-detail",
      props: true,
      component: MovementEntryOrderGTINDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:id/boxes",
      name: "movements-exit-order-boxes-detail",
      props: true,
      component: MovementExitOrderBoxesDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:orderId/boxes/:id/verifications/",
      name: "Movement_Exit_BoxVerificationList",
      props: true,
      component: MovementExitBoxVerificationList,
      meta: {
        auth: true
      }
    },

    {
      path: "/online/order/:orderId/boxes/:id/verifications/",
      name: "Sale_BoxVerificationView",
      props: true,
      component: SaleBoxVerificationList,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:orderId/boxes/:boxId/verifications/:id",
      name: "Order_BoxVerificationView",
      props: true,
      component: OrderBoxVerificationView,
      meta: {
        auth: true
      }
    },
    {
      path: "/online/order/:orderId/boxes/:boxId/verifications/:id/items",
      name: "Order_BoxVerificationViewItems",
      props: true,
      component: OrderBoxVerificationViewItems,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:orderId/boxes/:boxId/verifications/:id",
      name: "Movement_Exit_BoxVerificationView",
      props: true,
      component: MovementExitBoxVerificationView,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/exit/order/:orderId/boxes/:boxId/verifications/:id/items",
      name: "Movement_Exit_BoxVerificationViewItems",
      props: true,
      component: MovementExitBoxVerificationViewItems,
      meta: {
        auth: true
      }
    },
    
    {
      path: "/movements/entry/order/:orderId/boxes/:id/verifications/",
      name: "Movement_Entry_BoxVerificationList",
      props: true,
      component: MovementEntryBoxVerificationList,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:orderId/boxes/:boxId/verifications/:id",
      name: "Movement_Entry_BoxVerificationView",
      props: true,
      component: MovementEntryBoxVerificationView,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:orderId/boxes/:boxId/verifications/:id/items",
      name: "Movement_Entry_BoxVerificationViewItems",
      props: true,
      component: MovementEntryBoxVerificationViewItems,
      meta: {
        auth: true
      }
    },
    {
      path: "/movements/entry/order/:id/boxes",
      name: "movements-entry-order-boxes-detail",
      props: true,
      component: MovementEntryOrderBoxesDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/",
      name: "inventory-dashboard",
      component: InventoryDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/:id/detail",
      name: "inventory-detail",
      component: InventoryDetail,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/:id/detail-items",
      name: "inventory-detail-items",
      component: InventoryDetailItems,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/stocks",
      name: "inventory-stocks",
      component: InventoryStocks,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/stocks/:gtin/gtin",
      name: "inventory-gtin",
      component: InventoryGTINDetail,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/boxstocks",
      name: "inventory-boxstocks",
      component: InventoryBoxStocks,
      props: true,
      meta: {
        auth: true
      }
    },

    {
      path: "/inventory/global-stock",
      name: "inventory-global-stock",
      component: InventoryGlobalStock,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/inventory/global-item-stock",
      name: "inventory-global-item-stock",
      component: InventoryGlobalStockItems,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/pos/exits",
      name: "pos-exit-dashboard",
      component: PosExitDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/pos/exits/:id",
      name: "pos-exit-detail",
      props: true,
      component: PosExitDetail,
      meta: {
        auth: true
      }
    },
    {
      path: "/pos/",
      name: "pos-entry-dashboard",
      component: PosEntryDashboard,
      meta: {
        auth: true
      }
    },
    {
      path: "/pos/:id",
      name: "pos-entry-detail",
      component: PosEntryDetail,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: "/brand/dashboard",
      name: "brand-dashboard",
      component: () => import("@/views/Brand.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/brand/pallet-tracking",
      name: "pallet-tracking",
      component: () => import("@/views/brand/PalletTracking.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/cixxonia-printer/production",
      name: "print-register",
      component: () => import("@/views/printer/AristocrazyPrints.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/brand/box-tracking",
      name: "pallet-tracking",
      component: () => import("@/views/brand/BoxTracking.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/brand/pallet-tracking/:boxid",
      name: "pallet-tracking-detail",
      props: true,
      component: () => import("@/views/brand/PalletTrackingDetail.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/support",
      name: "support",
      props: true,
      component: () => import("@/views/Support.vue"),
      meta: {
        auth: true
      }
    }
  ]
});

router.beforeEach((to, _from, next) => {
  if (to.path === "/") {
    if (!store.getters.authenticated) {
      next({
        path: "/login"
      });
    } else {
      next({
        path: "/dashboard"
      });
    }
  }

  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.authenticated) {
      next({
        path: "/login"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
